import apiClient from './client';

export const fetchTransaction = async (id) => {
  const res = await apiClient.post('/invoice/transaction', { id });
  const transaction = res.data?.transaction;
  if (!transaction) {
    throw new Error('Transaction data not found in response');
  }
  return transaction;
};
